module.exports = __webpack_public_path__ + "static/img/船舶.7c439e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/船舶.jpg
// module id = 60P1
// module chunks = 1